/**
 * When true, 401 responses do not clear tokens or redirect — keeps the current page
 * and failed request visible in DevTools (default in webpack `development` builds).
 *
 * Set `ENABLE_AUTH_FAILURE_LOGOUT=1` to restore production-style logout while running `pnpm dev`.
 * Set `DISABLE_AUTH_FAILURE_LOGOUT=1` to force suppression in production builds (debug only).
 */
export function isAuthFailureLogoutDisabled() {
    if (typeof process !== 'undefined' && process.env.ENABLE_AUTH_FAILURE_LOGOUT === '1') {
        return false;
    }
    if (typeof process !== 'undefined' && process.env.DISABLE_AUTH_FAILURE_LOGOUT === '1') {
        return true;
    }
    return typeof process !== 'undefined' && process.env.NODE_ENV === 'development';
}
/** Wrong password on login — Monolithic clears state but stays on `/login`. */
export function isLoginAuthenticateRequest(url) {
    return Boolean(url &&
        (url.includes('user-management/api/authenticate-call-center') ||
            url.includes('user-management/api/authenticate')));
}
/**
 * Global session teardown applies only to **401** (invalid/expired token).
 * **403** is treated as “forbidden for this resource” and is left to the page/thunk.
 */
export function shouldForceLogoutOn401(url) {
    if (isAuthFailureLogoutDisabled()) {
        return false;
    }
    return !isLoginAuthenticateRequest(url);
}
export function logSuppressedAuthFailure(err, note) {
    const status = err.response?.status ?? 'unknown';
    const url = err.config?.url ?? '(no url)';
    const body = err.response?.data;
    console.group(`[auth] HTTP ${status} on ${url} — session kept (no redirect)`);
    if (note) {
        console.info(note);
    }
    if (body !== undefined) {
        console.info('response body:', body);
    }
    console.info('Inspect the failed request in the Network tab.');
    console.groupEnd();
}
